import graphql__c03f03dd4e43326fc23f from "./__generated__/EventModalRouteQuery.graphql.js";import { graphql } from "react-relay";
import { useParams } from "react-router";
import AppQueryRenderer from "../AppQueryRenderer";

import EventModal from "../Events/EventModal";
import ModalLoader from "../Modals/ModalLoader";

const EventModalRoute = props => {
  const { eventSlug: participativeModuleSlug } = useParams();

  return (
    <AppQueryRenderer
      key={participativeModuleSlug}
      query={EventModalRouteQuery}
      variables={{ participativeModuleSlug }}
      component={EventModal}
      loader={<ModalLoader />}
      additionalProps={props}
    />
  );
};

const EventModalRouteQuery = graphql__c03f03dd4e43326fc23f;

export default EventModalRoute;
